import axios from '@axios'

const route = 'financial/cash_flow'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    loadCashFlow(context, payload) {
      return axios.post(route, payload)
    },
  },
}
